import React from 'react';

import classnames from 'classnames';
import { connect } from 'react-redux';

import {
  COMPANY_DETAIL_URL,
  INVESTOR_DETAIL_URL,
  SERVICE_PROVIDER_DETAIL_URL,
  COMPANIES_URL,
  INVESTORS_URL,
  SERVICE_PROVIDERS_URL
} from 'global-constants';

import {
  GAClickOnFeaturedCompanyFromHome,
  GACSetIndexOfClickedCompany
} from 'shared/utils/GA';
import { getLabel } from 'shared/utils/investor';
import { getCompanyLabel } from 'shared/utils/getCompanyLabel';
import { substituteUrl } from 'shared/utils/substituteUrl';

import WithPush from 'shared/HOCs/WithPush';

import Button from 'shared/components/Button';
import Loader from 'shared/components/Loader';
import HomeCompanyBox from 'shared/components/HomeCompanyBox';
import FeaturedCompanyBox from 'shared/components/FeaturedCompanyBox';

import { fetchFeaturedCompanies } from 'pages/Home/ducks';

import { TABS } from './constants';

import styles from './styles.module.scss';

class FeaturedCompanies extends React.Component {
  state = {
    activeTab: TABS.VENDORS
  };

  componentDidMount() {
    this.fetchCompanies();
  }

  sendAnalytics = (slug, index) => {
    GAClickOnFeaturedCompanyFromHome(slug);
    GACSetIndexOfClickedCompany(index);
  };

  changeActiveTab = ({ tab }) => {
    const { activeTab } = this.state;

    if (tab === activeTab) {
      return;
    }

    this.setState({ activeTab: tab }, this.fetchCompanies);
  };

  fetchCompanies = () => {
    const { activeTab } = this.state;
    const { fetchFeaturedCompanies } = this.props;

    fetchFeaturedCompanies({ url: activeTab.url });
  };

  getCompanyDetailUrl = ({ slug }) => {
    const { activeTab } = this.state;

    if (activeTab === TABS.VENDORS) {
      return substituteUrl(COMPANY_DETAIL_URL, {
        companySlug: slug
      });
    }

    if (activeTab === TABS.INVESTORS) {
      return substituteUrl(INVESTOR_DETAIL_URL, { investorSlug: slug });
    }

    if (activeTab === TABS.SERVICE_PROVIDERS) {
      return substituteUrl(SERVICE_PROVIDER_DETAIL_URL, {
        serviceProviderSlug: slug
      });
    }
  };

  getDirectoryUrl = () => {
    const { activeTab } = this.state;

    switch (activeTab) {
      case TABS.VENDORS:
        return COMPANIES_URL;
      case TABS.INVESTORS:
        return INVESTORS_URL;
      case TABS.SERVICE_PROVIDERS:
        return SERVICE_PROVIDERS_URL;

      default:
        return COMPANIES_URL;
    }
  };

  render() {
    const { activeTab } = this.state;
    const { companies = [], fetchingCompanies, push } = this.props;

    const renderedCompanies = companies.map((item, index) => {
      return (
        <div
          key={`featured-company-${index}`}
          onClick={() => push(this.getCompanyDetailUrl({ slug: item.slug }))}>
          {activeTab === TABS.INVESTORS ? (
            <FeaturedCompanyBox
              featured={false}
              title={item.name}
              label={getLabel({ investor: item })}
              slug={item.slug}
              imageData={{
                image: item.logo,
                thumbnails: item.logo_thumbnails,
                width: 80,
                height: 80
              }}
              isInvestor={true}
            />
          ) : (
            <HomeCompanyBox
              title={item.name}
              headline={item.headline || item.description}
              className={styles.imageBoxWrapper}
              label={getCompanyLabel(item)}
              slug={item.slug}
              imageData={{
                image: item.logo,
                thumbnails: item.logo_thumbnails,
                width: 80,
                height: 80
              }}
              handleClick={() => this.sendAnalytics(item.slug, index)}
            />
          )}
        </div>
      );
    });

    return (
      <div className={styles.featuredCompaniesWrapper}>
        <h2 className={styles.title}>{activeTab.title}</h2>
        <div className={classnames('container', styles.container)}>
          <div className={styles.tabs}>
            {Object.keys(TABS).map(tabKey => (
              <div
                onClick={() => this.changeActiveTab({ tab: TABS[tabKey] })}
                className={classnames(styles.tab, {
                  [styles.active]: activeTab === TABS[tabKey]
                })}>
                {TABS[tabKey].label}
              </div>
            ))}
          </div>
          <div className={styles.companies}>
            {fetchingCompanies ? (
              <Loader className={styles.loader} />
            ) : (
              renderedCompanies
            )}
          </div>
          <Button
            color="orange-gradient"
            className={styles.button}
            onClick={() => push(this.getDirectoryUrl())}>
            View {activeTab.label}
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { companies, fetchingCompanies } = state.pages.home;

  return { companies, fetchingCompanies };
};

const mapDispatchToProps = { fetchFeaturedCompanies };

export default WithPush(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(FeaturedCompanies)
);
